import axios from 'axios'
import store from '@/stores';
import router from '@/routes';
import { LOGOUT, TOKEN } from '@/stores/types';
import { Message, Loading } from 'element-ui'
import { session } from '@/util'

/**
 *  错误返回码
 */
const STATUS = {
    SUCCESS: 200,
    /**
     * 系统错误
     */
    SYS_ERR: 500,
    /**
     * 业务请求异常
     */
    BIZ_ERR: 400,
    /**
     * 未授权
     */
    NO_AUTH: 401,
    /**
     * 服务连接异常
     */
    SEVER_ERR: 504
}

/**
 * 错误提示
 */
const MSG = {
    /**
     * 未知错误提示
     */
    unknown_error: '发生异常错误,请刷新页面重试,或联系程序员',
    /**
     * 未授权
     */
    no_auth: '账号授权信息已过期，请重新登录',
    /**
     * 服务连接异常提示
     */
    sever_error: '服务器不可用，请联系管理员'
}

/**
 * 统计一次性发送了多少个接口，为0时关闭遮罩层
 */
let needLoadingRequestCount = 0;

/**
 * element-ui loading 实例
 */
let loading;

function showFullScreenLoading() {
    if (needLoadingRequestCount === 0) {
        startLoading()
    }
    needLoadingRequestCount++
}

function tryHideFullScreenLoading() {
    if (needLoadingRequestCount <= 0) return
    needLoadingRequestCount--
    if (needLoadingRequestCount === 0) {
        endLoading()
    }
}

function startLoading() {
    loading = Loading.service({
        lock: false,
        text: '加载中……',
        background: 'rgba(0, 0, 0, 0.7)'
    })
}

function endLoading() {
    loading.close()
}

function showTip(msg) {
    Message({
        message: msg,
        type: 'error',
        duration: 5 * 1000
    });
}

const PREFIX = '/suguan'
export default function _fetch(options) {
    let urlPrefix = PREFIX;
    if (options.isLogin || options.isLocal) urlPrefix = '';
    // if (options.isLocal) urlPrefix = '/local';
    return new Promise((resolve, reject) => {
        const instance = axios.create({
            baseURL: urlPrefix,
            timeout: 500000,
            headers: {
                'Content-Type': 'application/json',
                'showLoading': true
            }
        });

        // http request 拦截器
        instance.interceptors.request.use(config => {
            const token = session('token');
            if (config.headers.showLoading) {
                showFullScreenLoading()
            }
            if (token && token.accesstoken) {
                Object.assign(config.headers, { 'wcyc_token': token.accesstoken })
            }
            return config;
        }, err => {
            return Promise.reject(err);
        });

        // http response 拦截器
        instance.interceptors.response.use((response) => {
            tryHideFullScreenLoading()
            return response
        }, (error) => {
            tryHideFullScreenLoading()
            return Promise.reject(error)
        })

        instance(options).then(response => {
            const res = response.data;
            resolve(res);
            if (res.token) {
                let tokensession = {
                    logintime: new Date(),
                    accesstoken: res.token
                }
                store.commit(TOKEN, tokensession)
            }

        }).catch(error => {
            if (error.response) {
                const status = error.response.status;
                switch (status) {
                    case STATUS.NO_AUTH: //未登录
                        showTip(MSG.no_auth);
                        store.commit(LOGOUT); // 401 清除token信息并跳转到登录页面
                        router.replace({
                            path: '/logining',
                            query: { from: router.currentRoute.fullPath }
                        })
                        break;
                    case STATUS.SYS_ERR:
                        showTip(MSG.unknown_error);
                        break;
                    default:
                        showTip(error.response.statusText);
                        break;
                }
                reject(error.response.data);
            } else {
                showTip(MSG.unknown_error);
                reject(error)
            }
        });
    });
}

export function pageInfo(page, size) {
    return '&pageNum=' + page + '&pageSize=' + size;
}



// WEBPACK FOOTER //
// ./src/api/fetch.js